(function initializeCampaign() {
  'use strict';
  var homepage = document.body.classList.contains('template-index');
  var campaignProduct = /\/products\/outrage-black-friday-editie\/?$/.test(location.pathname);
  if (!document.querySelector('main') || document.querySelector('[data-sano-campaign-effects]')) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var colors = ['#F1A03E', '#C25AD8', '#E08E3E', '#7D3FA0', '#F8F2F4'];
  var selector = '.sano-launch__actions a, .sano-golden-ticket, .sano-prize-card, .sano-home-product-card, .sano-home-product-card__footer a, .sano-ticket-directory summary, .sano-home__text-link, .sano-home__button, nav[aria-label="Primary navigation"] a, nav[aria-label="Mobile navigation"] a';
  var targets = document.querySelectorAll(selector);
  var effects = document.createElement('div');
  effects.className = 'sano-campaign-effects';
  effects.dataset.sanoCampaignEffects = '';
  effects.setAttribute('aria-hidden', 'true');
  document.body.appendChild(effects);
  var lifecycle = homepage ? new AbortController() : null;
  var interactionOptions = lifecycle ? {signal:lifecycle.signal} : undefined;
  if(homepage){
    window.sanoHomeBurstCleanup=function(){lifecycle.abort();effects.remove();delete window.sanoHomeBurstCleanup;};
    document.addEventListener('shopify:section:unload',window.sanoHomeBurstCleanup,{once:true,signal:lifecycle.signal});
    if(!window.sanoHomeBurstLifecycleBound){window.sanoHomeBurstLifecycleBound=true;document.addEventListener('shopify:section:load',function(){if(!document.querySelector('[data-sano-campaign-effects]'))initializeCampaign();});}
    window.addEventListener('pagehide',window.sanoHomeBurstCleanup,{once:true,signal:lifecycle.signal});
  }
  var lastBurst = new WeakMap();
  function burst(target, force) {
    if (reduced.matches || !target.isConnected) return;
    var now = performance.now();
    if (!force && now - (lastBurst.get(target) || -1000) < 650) return;
    lastBurst.set(target, now);
    var rect = target.getBoundingClientRect();
    var nav = !!target.closest('nav');
    var count = nav ? 1 : target.matches('.sano-prize-card') ? 3 : 4;
    var variant = Number(target.dataset.sparkleVariant || 0);
    // One viewport overlay, at most twelve particles; no layout nodes in controls.
    while (effects.childElementCount + count > 12) effects.firstElementChild.remove();
    for (var n = 0; n < count; n++) {
      var particle = document.createElement('i');
      particle.className = 'sano-campaign-burst';
      // Edges only: outward motion never covers the product photograph.
      var left = n % 2 === 0;
      var x = nav ? rect.right - 3 : left ? rect.left - 3 : rect.right + 3;
      var y = nav ? rect.bottom : rect.top + rect.height * ([.2, .75, .65, .3][(n + variant) % 4]);
      particle.style.left = x + 'px';
      particle.style.top = y + 'px';
      if (nav) { particle.style.width = '4px'; particle.style.height = '4px'; }
      particle.style.setProperty('--spark-x', (left ? -1 : 1) * (12 + variant * 3) + 'px');
      particle.style.setProperty('--spark-y', (n % 2 ? 9 : -13) + 'px');
      particle.style.setProperty('--spark-delay', (n * 45 + variant * 25) + 'ms');
      particle.style.backgroundColor = colors[(n + variant) % colors.length];
      effects.appendChild(particle);
      particle.addEventListener('animationend', function (event) { event.currentTarget.remove(); }, { once: true });
      window.setTimeout(function (node) { node.remove(); }, 1400, particle);
    }
  }
  targets.forEach(function (target, index) {
    target.classList.add('sano-campaign-hover');
    if (!target.dataset.sparkleVariant) target.dataset.sparkleVariant = String(index % 3);
    target.addEventListener('pointerenter', function (event) { if (fine.matches && event.pointerType !== 'touch') burst(target); }, interactionOptions);
    target.addEventListener('click', function (event) {
      if (event.target.closest('.sano-campaign-hover') !== target) return;
      burst(target, true);
      if (!reduced.matches) {
        target.classList.remove('sano-campaign-pulse');
        void target.offsetWidth;
        target.classList.add('sano-campaign-pulse');
        window.setTimeout(function () { target.classList.remove('sano-campaign-pulse'); }, 550);
      }
    }, interactionOptions);
    target.addEventListener('focusin', function (event) { if (event.target.matches(':focus-visible') && event.target.closest('.sano-campaign-hover') === target) burst(target); }, interactionOptions);
  });
  // Continuous perimeter light plus local fields. Product photos and copy stay clear.
  document.body.classList.add('sano-campaign-page');
  // Homepage continuous light is owned by its existing, bounded scroll-energy pool.
  if(homepage)return;
  var mobile = window.matchMedia('(max-width: 749px)');
  var types = ['star', 'dust', 'glint', 'violet', 'mote', 'streak', 'cluster'];
  function sparkle(index) {
    var dot = document.createElement('i');
    dot.className = 'sano-campaign-particle sano-campaign-particle--' + types[index % types.length];
    dot.style.setProperty('--particle-life', (6.4 + index % 9 * 1.13) + 's');
    dot.style.setProperty('--particle-delay', (-index * 1.79) + 's');
    dot.style.setProperty('--particle-size', (index % 3 === 0 ? 10 : 7) + 'px');
    dot.style.setProperty('--particle-dx', (index % 2 ? 3 : -3) + 'px');
    dot.style.backgroundColor = colors[index % colors.length];
    return dot;
  }
  var ambient = document.createElement('div');
  ambient.className = 'sano-campaign-ambient';
  ambient.setAttribute('aria-hidden', 'true');
  for (var n = 0; n < 24; n++) {
    var dot = sparkle(n);
    dot.style.setProperty('--ambient-y', (5 + Math.floor(n / 2) * 7.6) + '%');
    dot.style.setProperty('--ambient-mobile-y', (5 + Math.floor(n / 2) * 16.7) + '%');
    ambient.appendChild(dot);
  }
  document.body.appendChild(ambient);
  // Edge-to-edge review cards scroll through the perimeter. Mask their reading
  // band rather than allowing even a decorative glint to cross review text.
  var rail = document.querySelector('.sano-home-reviews__rail');
  var maskFrame = 0;
  function protectReviewText() {
    maskFrame = 0;
    if (!rail) return;
    var rect = rail.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > innerHeight) {
      ambient.style.maskImage = 'none';
      delete ambient.dataset.clearTop;
      delete ambient.dataset.clearBottom;
      return;
    }
    var top = Math.max(0, rect.top - 12);
    var bottom = Math.min(innerHeight, rect.bottom + 12);
    ambient.style.maskImage = 'linear-gradient(to bottom,#000 0px,#000 ' + top + 'px,transparent ' + top + 'px,transparent ' + bottom + 'px,#000 ' + bottom + 'px,#000 100%)';
    ambient.dataset.clearTop = String(top);
    ambient.dataset.clearBottom = String(bottom);
  }
  function scheduleMask() { if (!maskFrame) maskFrame = requestAnimationFrame(protectReviewText); }
  window.addEventListener('scroll', scheduleMask, { passive: true });
  window.addEventListener('resize', scheduleMask, { passive: true });
  if (rail && 'ResizeObserver' in window) new ResizeObserver(scheduleMask).observe(rail);
  protectReviewText();
  var fields = [];
  var plans = [
    ['header.header', 4, 1, 'header'],
    ['.sano-launch', 38, 22, 'hero'],
    
    ['.sano-ticket-campaign', 22, 14, 'tickets'],
    
    
    ['.sano-home-products', 30, 18, 'products'],
    ['.sano-home-reviews', 24, 14, 'reviews'],
    ['.sano-knowledge', 26, 16, 'knowledge'],
    ['.sano-faq', 24, 14, 'faq'],
    ['.bwp-footer', 24, 14, 'footer'],
    ['.sano-product-buybox', 28, 16, 'campaign-product'],
    ['.product-recommendations', 20, 12, 'recommendations'],
    ['.sano-creatine', 30, 18, 'creatine'],
    ['.sano-creatine-focus', 18, 12, 'creatine-focus'],
    ['.sano-creatine-science', 20, 12, 'creatine-science'],
    ['.sano-creatine-use', 18, 12, 'creatine-use'],
    ['.sano-creatine-reviews', 18, 12, 'creatine-reviews']
  ];
  if (!homepage && !document.querySelector('.sano-product-buybox,.sano-creatine')) plans.push(['main', 40, 24, 'page']);
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var field = entry.target.querySelector(':scope > .sano-campaign-field');
      if (!field) return;
      field.classList.toggle('is-active', entry.isIntersecting);
      if (entry.isIntersecting) field.classList.add('is-entered');
    });
  }, { rootMargin: '70px', threshold: 0 }) : null;
  // Place light in real interior whitespace. Never paint over readable lines,
  // photographs, controls, or opaque cards. Deterministic sampling avoids jitter.
  function placeFields() {
    var measurements=fields.map(function (field) {
      var section = field.parentElement, base = section.getBoundingClientRect();
      if (!base.width || !base.height) return null;
      var blocked = [];
      section.querySelectorAll('h1,h2,h3,p,summary,a,button,label,img,video,.sano-home-product-card,.sano-home-reviews__rail,.sano-golden-ticket').forEach(function (node) {
        if (node.closest('.sano-campaign-field') || !node.getClientRects().length) return;
        if (node.closest('details:not([open])') && !node.closest('summary')) return;
        var boxes;
        if (node.matches('h1,h2,h3,p,label')) {
          var range = document.createRange(); range.selectNodeContents(node);
          boxes = Array.from(range.getClientRects());
        } else boxes = [node.getBoundingClientRect()];
        boxes.forEach(function (r) { if (r.width && r.height) blocked.push({left:r.left-base.left-13,right:r.right-base.left+13,top:r.top-base.top-30,bottom:r.bottom-base.top+22}); });
      });
      return {field:field,base:base,blocked:blocked};
    });
    measurements.forEach(function (measurement) {
      if (!measurement) return;
      var field=measurement.field,base=measurement.base,blocked=measurement.blocked;
      var points = [];
      Array.from(field.children).forEach(function (dot,index) {
        var found = false;
        for (var n=0;n<240;n++) {
          var seed=index*37+n;
          var x=16+((seed*.61803398875+.13)%1)*Math.max(0,base.width-32);
          var y=24+((seed*.38196601125+seed*seed*.071+.17)%1)*Math.max(0,base.height-48);
          if (blocked.some(function(r){return x>r.left&&x<r.right&&y>r.top&&y<r.bottom;})) continue;
          if (points.some(function(p){return Math.hypot(p.x-x,p.y-y)<(mobile.matches?25:38);})) continue;
          dot.style.left=x+'px';dot.style.right='auto';dot.style.top=y+'px';
          dot.style.setProperty('--particle-size',(index%7===0?14:9)+'px');
          dot.style.display='block';points.push({x:x,y:y});found=true;break;
        }
        if(!found)dot.style.display='none';
      });
      field.dataset.interior=String(points.filter(function(p){return p.x>base.width*.12&&p.x<base.width*.88;}).length);
      field.dataset.placed=String(points.length);
    });
    updateScrollLight();
  }
  var scrollFrame=0;
  function updateScrollLight(){
    scrollFrame=0;
    // Measure every field before writing styles: avoid alternating layout reads and writes.
    var progressValues=fields.map(function(field){
      var r=field.parentElement.getBoundingClientRect();
      return Math.max(-1,Math.min(1,(innerHeight/2-r.top-r.height/2)/innerHeight));
    });
    fields.forEach(function(field,index){
      var progress=progressValues[index];
      field.style.setProperty('--scroll-light',reduced.matches?'0px':(progress*6).toFixed(2)+'px');
      field.style.setProperty('--wave-x',(48+progress*14).toFixed(2)+'%');
    });
  }
  function scheduleScrollLight(){if(!scrollFrame)scrollFrame=requestAnimationFrame(updateScrollLight);}
  window.addEventListener('scroll',scheduleScrollLight,{passive:true});
  document.addEventListener('toggle',function(e){if(e.target.closest('.sano-ticket-campaign'))setTimeout(placeFields,600);},true);
  if('ResizeObserver' in window){var geometryObserver=new ResizeObserver(function(){requestAnimationFrame(placeFields);});}
  function buildFields() {
    if (observer) observer.disconnect();
    if(geometryObserver)geometryObserver.disconnect();
    fields.forEach(function (field) { field.remove(); });
    fields = [];
    plans.forEach(function (plan, zoneIndex) {
      var section = document.querySelector(plan[0]);
      if (!section) return;
      if (getComputedStyle(section).position === 'static') section.classList.add('sano-campaign-positioned');
      var field = document.createElement('div');
      field.className = 'sano-campaign-field';
      field.dataset.zone = plan[3];
      field.setAttribute('aria-hidden', 'true');
      var count = plan[mobile.matches ? 2 : 1];
      if(mobile.matches)count=Math.max(4,Math.ceil(count*.65));
      for (var index = 0; index < count; index++) {
        var dot = sparkle(zoneIndex * 5 + index);
        dot.style.setProperty('--field-y', (14 + index * 67 / Math.max(1, count - 1)) + '%');
        if (plan[3] === 'reviews') dot.style.setProperty('--field-y', (index < count / 2 ? 4 + index * 3 : 93 + (index % 2) * 3) + '%');
        field.appendChild(dot);
      }
      section.appendChild(field);
      fields.push(field);
      if(geometryObserver)geometryObserver.observe(section);
      if (observer) observer.observe(section);
      else field.classList.add('is-active', 'is-entered');
    });
    placeFields();
  }
  buildFields();
  mobile.addEventListener('change', buildFields);
  window.addEventListener('resize', placeFields, { passive: true });
  reduced.addEventListener('change', function () { if (reduced.matches) effects.replaceChildren(); updateScrollLight(); });

  var chapter = document.querySelector('[data-sano-ticket-config]');
  if (!chapter) return;
  var reveal = chapter.querySelector('[data-sano-ticket-reveal]');
  var disclosure = chapter.querySelector('.sano-ticket-directory');
  if (reveal && disclosure) {
    reveal.addEventListener('click', function () { disclosure.open = !disclosure.open; });
    disclosure.addEventListener('toggle', function () { reveal.setAttribute('aria-expanded', String(disclosure.open)); });
  }
  var directory = chapter.querySelector('[data-sano-ticket-list]');
  var state = chapter.querySelector('[data-sano-ticket-state]');
  fetch(chapter.dataset.sanoTicketConfig, { credentials: 'omit' }).then(function (response) {
    if (!response.ok) throw new Error('Ticket configuration unavailable');
    return response.json();
  }).then(function (config) {
    var tickets = config.tickets;
    if (!Array.isArray(tickets) || tickets.length !== 50) throw new Error('Invalid ticket count');
    tickets.forEach(function (ticket, index) {
      if (ticket.number !== String(index + 1).padStart(2, '0') || !['available', 'found'].includes(ticket.status) || !(ticket.prize === null || typeof ticket.prize === 'string')) throw new Error('Invalid ticket configuration');
    });
    var fragment = document.createDocumentFragment();
    tickets.forEach(function (ticket) {
      var item = document.createElement('li');
      var number = document.createElement('strong');
      number.textContent = '#' + ticket.number;
      var prize = document.createElement('span');
      prize.textContent = ticket.prize || 'Prijs nog verborgen';
      var status = document.createElement('small');
      status.textContent = ticket.status === 'found' ? 'Gevonden' : 'Beschikbaar';
      item.append(number, prize, status);
      fragment.appendChild(item);
    });
    directory.replaceChildren(fragment);
    state.textContent = tickets.some(function (ticket) { return ticket.prize !== null; }) ? '50 unieke nummers. Bekijk de bekendgemaakte prijskoppelingen.' : '50 unieke nummers. De prijskoppelingen worden later bekendgemaakt.';
    chapter.dataset.sanoTicketsReady = 'true';
  }).catch(function () {
    state.textContent = 'De ticketnummers zijn op dit moment niet beschikbaar. Probeer het later opnieuw.';
  });
}());
